import React from 'react';
import { Icon } from '@ontruck/orc';

const Liftgate = ({ cellData }) => {
  return cellData ? <Icon size="4rem" glyph="extras-liftgate" color="grey500" /> : null;
};

export default Liftgate;
